import React from 'react'
import BaseIcon from 'react-icon-base'

const VN = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>VN</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#E82E2E" xlinkHref="#a" />
      <path
        fill="#FED949"
        d="M6 6l3.077 1.846L8 11l2.5-2.333L13 11l-1.077-3.154L15 6H6zm6 0H9l1.5-3L12 6z"
        mask="url(#b)"
      />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default VN
